/* Disclosure presentation only. Shopify + explore-access.js own signup success. */
(function () {
  const root = document.querySelector('[data-newsletter-edge]');
  if (!root || root.dataset.newsletterReady) return;
  const details = root.querySelector('[data-newsletter-details]');
  const summary = details?.querySelector('summary');
  const closeButton = root.querySelector('[data-newsletter-close]');
  const heading = root.querySelector('[data-newsletter-heading]');
  if (!details || !summary || !closeButton) return;
  root.dataset.newsletterReady = 'true';
  closeButton.hidden = false;
  const hasResponse = Boolean(root.querySelector('[data-club-posted], [data-newsletter-error]'));
  root.classList.toggle('has-post-response', hasResponse);
  const close = (restoreFocus) => {
    details.open = false;
    root.classList.remove('is-open');
    if (restoreFocus) {
      const target = root.classList.contains('is-context-hidden') ? document.querySelector('#MainContent') : summary;
      target?.focus({ preventScroll: true });
    }
  };
  const sync = () => {
    root.classList.toggle('is-open', details.open);
    if (details.open) heading?.focus({ preventScroll: true });
  };
  details.addEventListener('toggle', sync);
  closeButton.addEventListener('click', () => close(true));
  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !details.open) return;
    event.preventDefault(); close(true);
  });
  document.addEventListener('click', (event) => {
    if (details.open && !root.contains(event.target)) close(false);
  });
  let purchaseStarted = false;
  const visiblePurchase = new Set();
  const syncVisibility = () => root.classList.toggle('is-context-hidden', purchaseStarted || visiblePurchase.size > 0);
  document.addEventListener('input', (event) => {
    if (!event.target.closest?.('[data-personalized-form]')) return;
    purchaseStarted = true; syncVisibility();
  });
  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('[data-personalized-form]')) return;
    purchaseStarted = true; syncVisibility();
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.isIntersecting ? visiblePurchase.add(entry.target) : visiblePurchase.delete(entry.target));
      syncVisibility();
    }, { threshold: 0.01 });
    document.querySelectorAll('[data-personalized-form], .premium-contact__actions, .hero__actions').forEach((element) => observer.observe(element));
  }
  // Only Liquid's real posted-success/error branch renders the details open.
  // No timers, click-to-subscribe, auto-opening, or browser-stored addresses.
  sync();
})();
